import { render, staticRenderFns } from "./DashboardGenericChartView.vue?vue&type=template&id=67f456ba&scoped=true&"
import script from "./DashboardGenericChartView.vue?vue&type=script&lang=js&"
export * from "./DashboardGenericChartView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGenericChartView.vue?vue&type=style&index=0&id=67f456ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f456ba",
  null
  
)

/* custom blocks */
import block0 from "./DashboardGenericChartView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports